import { CreateButton, Datagrid, DateField, Filter, FunctionField, List, ReferenceArrayInput, ReferenceInput, SelectArrayInput, SelectInput, TextField, TopToolbar } from 'ra-ui-materialui';
import { CheckChainUsesModule, ModuleKey, ReferenceArrayFieldWithLimit } from '../../components';
import FeatureIntro from '../../components/FeatureIntro';
import Permission from '../../components/Permission';
import { PERMISSIONS } from '../../constants';
import { getChainId } from '../../lib';
import ManualLinkButton from '../../manual/components/ManualLinkButton';
import { Box, Typography } from '@mui/material';
import { useListContext } from 'react-admin';
import CloneAttendantGoalBoardButton from './CloneAttendantGoalBoardButton';

const AttendantTargetList = (props) => {

    const filterDefaultValues: any = { isDisabled: false };
    const chainId = getChainId();

    if (chainId) {
        filterDefaultValues.chainId = chainId;
    } else {
        return (
            <Box>
                <Typography>Selecione uma rede para visualizar as informações</Typography>
            </Box>
        );
    }

    const ListFilters = () => {
        const { filterValues } = useListContext();
        return (
            <Filter>
                <SelectInput
                    label="Status"
                    source="isDisabled"
                    choices={[{ label: 'Ativos', value: false }, { label: 'Inativos', value: true }]}
                    optionText="label"
                    optionValue="value"
                    emptyText="Todos"
                    alwaysOn
                />
                {
                    Permission({
                        permission: PERMISSIONS.ADMIN, children:
                            <ReferenceInput
                                reference="chains"
                                source="chainId"
                                style={{ minWidth: 220 }}
                                defaultValue={getChainId()}
                                sort={{ field: 'name', order: 'ASC' }}
                                perPage={9999}
                            >
                                <SelectInput label="Rede" optionText="name" />
                            </ReferenceInput>
                    })
                }
                <ReferenceArrayInput
                    reference="stations"
                    source="stationIds"
                    sort={{ field: 'name', order: 'ASC' }}
                    perPage={9999}
                    style={{ minWidth: 220, marginBottom: -16 }}
                    filter={filterValues.chainId ? { chainId: filterValues.chainId } : {}}
                    alwaysOn
                >
                    <SelectArrayInput label="Postos" optionText="name" />
                </ReferenceArrayInput>
                <ReferenceArrayInput
                    reference="fuels"
                    source="fuelIds"
                    style={{ minWidth: 220 }}
                    sort={{ field: "name", order: "ASC" }}
                    alwaysOn
                >
                    <SelectArrayInput label="Combustíveis" optionText="name" />
                </ReferenceArrayInput>
            </Filter>
        );
    };

    return (
        <Permission permission={PERMISSIONS.ATTENDANT_TARGET}>
            <CheckChainUsesModule module={ModuleKey.ATTENDANT_TARGET}>
                <List
                    {...props}
                    title="Quadros"
                    sort={{ field: 'createdAt', order: 'DESC' }}
                    filterDefaultValues={filterDefaultValues}
                    filters={<ListFilters />}
                    exporter={false}
                    actions={
                        <TopToolbar>
                            <FeatureIntro id="manual-meta-frentista" title="Manual de Meta de Frentista" description="Acesse o manual completo sobre metas de frentista para entender quadros, regras, monitoramento e modo TV.">
                                <ManualLinkButton slug="meta-de-frentista" label="Manual" />
                            </FeatureIntro>
                            <CreateButton />
                        </TopToolbar>
                    }
                    disableSyncWithLocation
                >
                    <Datagrid bulkActionButtons={false} rowClick="show">
                        <TextField source="code" label="Código" />
                        <TextField source="name" label="Nome" />
                        <ReferenceArrayFieldWithLimit source="stationIds" reference="stations" label="Postos" name="posto" sxChip={{ height: 22, fontSize: '0.72rem' }} />
                        <DateField source="startDate" label="Data de início" textAlign="center" emptyText="--" />
                        <DateField source="endDate" label="Data de fim" textAlign="center" emptyText="--" />
                        <FunctionField
                            render={record => record && record.isDisabled ? "Inativo" : "Ativo"}
                            label="Status"
                            textAlign="center"
                        />
                        <DateField source="disabledAt" label="Desativado em" showTime textAlign="center" emptyText="--" />
                        <CloneAttendantGoalBoardButton />
                    </Datagrid>
                </List>
            </CheckChainUsesModule>
        </Permission>
    );
};

export default AttendantTargetList;
